// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Footer/Footer.css
// module id = 1377
// module chunks = 193